import React, { useState } from "react"
import GuestDonationCheckoutModal from "../GuestDonationCheckoutModal"

interface PostDonationComponentLoggedOutProps {
  postId: number
  bandId: number
  postTitle: string
  donationText?: string | null
}

// Mirrors TicketPurchaseComponentLoggedOut: logged-out fans can donate
// straight away via a soft-registered guest account instead of being forced
// through full signup first.
export const PostDonationComponentLoggedOut: React.FC<
  PostDonationComponentLoggedOutProps
> = ({ postId, bandId, postTitle, donationText }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <button
        type="button"
        className="w-auto px-4 py-2 rounded border border-green-700 text-green-700 font-bold text-base bg-transparent focus:outline-none"
        onClick={() => setShowModal(true)}
      >
        Donate to the Show
      </button>

      {showModal && (
        <GuestDonationCheckoutModal
          postId={postId}
          bandId={bandId}
          postTitle={postTitle}
          donationText={donationText}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}

export default PostDonationComponentLoggedOut
